export const getSelectedRetailerId = (state) =>
  state.duplicateOrdersModal.selectedRetailerId
export const getRetailerSearchText = (state) =>
  state.duplicateOrdersModal.retailerSearchText
